import { homeConstants } from "../constants";

export default function (
  state = {
    data: null,
    isProgress: false,
    status: true,
  },
  action
) {
  switch (action.type) {
    case homeConstants.SAVE_ZIP_CODE_REQUEST:
      return {
        data: null,
        zipDataStatus: true,
        isProgress: true,
      };
    case homeConstants.SAVE_ZIP_CODE_SUCCESS:
      return {
        data: action.response.data,
        status: action.response.success,
        isProgress: false,
      };
    case homeConstants.SAVE_ZIP_CODE_FAILURE:
      return {
        data: null,
        error: action.error,
        isProgress: false,
      };
    default:
      return state;
  }
}
